import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { ShoppingCart, GraduationCap, Crown, Star } from 'lucide-react';

export default function CustomerDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get('/customer/dashboard').then(r => { setData(r.data); setLoading(false); }).catch(() => setLoading(false)); }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--store-primary, #2D6CDF)]" /></div>;

  const s = data?.stats || {};

  return (
    <div data-testid="customer-dashboard">
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 mb-6" style={{ fontFamily: 'Plus Jakarta Sans' }}>Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <Card className="stat-card"><CardContent className="p-5">
          <ShoppingCart size={20} className="text-[var(--store-primary, #2D6CDF)] mb-2" /><p className="text-2xl font-bold">{s.total_orders || 0}</p><p className="text-xs text-slate-500">Pesanan</p>
        </CardContent></Card>
        <Card className="stat-card"><CardContent className="p-5">
          <GraduationCap size={20} className="text-emerald-500 mb-2" /><p className="text-2xl font-bold">{s.enrolled_courses || 0}</p><p className="text-xs text-slate-500">Kursus</p>
        </CardContent></Card>
        <Card className="stat-card"><CardContent className="p-5">
          <Crown size={20} className="text-amber-500 mb-2" /><p className="text-2xl font-bold">{s.active_memberships || 0}</p><p className="text-xs text-slate-500">Membership</p>
        </CardContent></Card>
        <Card className="stat-card bg-gradient-to-br from-amber-50 to-orange-50 border-amber-200"><CardContent className="p-5">
          <Star size={20} className="text-amber-500 mb-2" /><p className="text-2xl font-bold">{s.loyalty_points || 0}</p><p className="text-xs text-slate-500">Poin Loyalty</p>
        </CardContent></Card>
      </div>
      <Card className="border-slate-200 shadow-sm"><CardContent className="p-6">
        <h3 className="font-semibold mb-4">Pesanan Terbaru</h3>
        <table className="w-full text-sm">
          <thead><tr className="border-b border-slate-100">
            <th className="text-left py-2 px-3 text-slate-500 font-medium">Order</th>
            <th className="text-left py-2 px-3 text-slate-500 font-medium">Total</th>
            <th className="text-left py-2 px-3 text-slate-500 font-medium">Status</th>
          </tr></thead>
          <tbody>
            {(data?.recent_orders || []).map((o, i) => (
              <tr key={i} className="border-b border-slate-50">
                <td className="py-2 px-3 font-mono text-xs">{o.order_number}</td>
                <td className="py-2 px-3">Rp {new Intl.NumberFormat('id-ID').format(o.total)}</td>
                <td className="py-2 px-3"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${o.payment_status === 'paid' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>{o.status}</span></td>
              </tr>
            ))}
            {!data?.recent_orders?.length && <tr><td colSpan={3} className="py-8 text-center text-slate-400">Belum ada pesanan</td></tr>}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
